import { createFileRoute } from '@tanstack/react-router';
import { ApplicationsPage } from '../../../opin-applications/applications-page.tsx';

export const Route = createFileRoute('/aplicacoes/')({
  component: ApplicationsPage,
});
